/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { lAC_RemoveCartLinesAsync } from '../custom-actions/DataActionExtension.g';
import { ILAC_AuthToken } from '../custom-actions/DataServiceEntities.g';
import { withFreshToken } from '../utils/authService';
import * as Entities from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';

/**
 * RemoveCartLines Input Action
 */
export class RemoveCartLinesInput implements Msdyn365.IActionInput {
    public authTokenCookie: ILAC_AuthToken;
    public cartId: string;
    public customerId: string;
    public cartLineIds: string[];

    constructor(cartId: string, customerId: string, cartLineIds: string[], authTokenCookie: ILAC_AuthToken) {
        this.authTokenCookie = authTokenCookie;
        this.cartId = cartId;
        this.customerId = customerId;
        this.cartLineIds = cartLineIds;
    }

    // a cache object type and an appropriate cache key
    public getCacheKey = () => `LAC_REMOVECARTLINES`;
    public getCacheObjectType = () => 'LAC_REMOVECARTLINES';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

async function removeCartLinesAsync(input: RemoveCartLinesInput, ctx: Msdyn365.IActionContext): Promise<Entities.Cart | undefined> {
    try {
        const result = await withFreshToken(ctx, input.authTokenCookie, async carried =>
            lAC_RemoveCartLinesAsync({ callerContext: ctx }, carried, input.cartId, input.customerId, input.cartLineIds)
        );
        if (result) {
            return result;
        }
    } catch (error) {
        console.log('Error removing cart lines:', error);
        throw error;
    }

    return undefined;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<Entities.Cart | undefined>>removeCartLinesAsync,
    id: 'LAC_RemoveCartLines'
});
